import { Injectable } from '@angular/core'
import { environment } from '@environments/environment'
import { AbstractContentSidebarStateService } from './abstract-content-sidebar-state.service'
import { CertificateHolderNavigationItem } from '@app/layout/sidebar/models/certificate-holder-navigation-item.model'
import { Observable } from 'rxjs'

@Injectable({
  providedIn: 'root'
})
export class CertificateHolderStateService extends AbstractContentSidebarStateService<CertificateHolderNavigationItem> {
  protected override readonly apiUrl = environment.chApiUrl
  protected override readonly subsystemName = 'Certificate Holder List Loading'
  protected override readonly errorDescription = 'Could not load the list of Certificate Holders.'
  protected override readonly listEndpoint = 'navigation-list'

  public loadMoreCertificateHolderItems(page: number, size = 20): Observable<CertificateHolderNavigationItem[]> {
    return this.loadMoreItems(page, size)
  }
}
